import { useParams } from "react-router-dom";
import { Container, DetailContainer } from "./styles";
import { useEffect, useState } from "react";
import { NoticeApi } from "../../api/Notice.api";
import Notice from "../../models/Notice.model";
import moment from "moment";

export default function NoticeDetailPage() {

  const {id} = useParams()

  const [notice, setNotice] = useState<Notice>()

  useEffect(() => {
    getNotice()
  }, [id])

  const getNotice = () => {
    if(id === undefined) return

    NoticeApi.one(parseInt(id))
    .then(result => {
      setNotice(result)
    }).catch(console.error)
  }

  if(notice === undefined) return <></>

  return (
    <DetailContainer>
      <div className="inner">
        <p className="fs24">{notice.title}</p>
        <p className="date">{moment(notice.createdAt).format('YYYY.MM.DD')}</p>
        <p className="description">{notice.description}</p>
      </div>
    </DetailContainer>
  )
}